import { render, staticRenderFns } from "./ArchiveGlobalPage.vue?vue&type=template&id=c3660cae&"
import script from "./ArchiveGlobalPage.vue?vue&type=script&lang=js&"
export * from "./ArchiveGlobalPage.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveGlobalPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports